import type { AnyAction, Dispatch } from 'redux';
import { connect } from 'react-redux';

import { openNewRequestModal } from 'modules/requests/service';
import { translationSelector } from 'modules/translations/duck';
import {
  setItem as setSSItem,
  propertyTypeSSKey,
  addressFormSSKey,
  ageFormSSKey,
  corporateindividualFormSSKey,
} from 'utils/sessionStorage';
import type { RootState } from 'store/types';

import type { BannerZipcodeProps } from './BannerZipcode';
import BannerZipcode from './BannerZipcode';

const mapStateToProps = (state: RootState, props: { translationId: string }) => ({
  translation: translationSelector(state, props),
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  async openRequestModal({
    age,
    address,
    city,
    prefecture,
    cityGroupName,
    jobTypeId,
    propertyType,
    corporateindividual,
  }: {
    address?: string;
    age?: string | number;
    city?: BannerZipcodeProps['city'];
    cityGroupName?: BannerZipcodeProps['cityGroupName'];
    corporateindividual?: string;
    jobTypeId?: string;
    prefecture?: BannerZipcodeProps['prefecture'];
    propertyType?: string;
  }) {
    setSSItem(addressFormSSKey, address ?? '');
    if (propertyType) setSSItem(propertyTypeSSKey, propertyType);
    if (age) setSSItem(ageFormSSKey, age.toString());
    if (corporateindividual) setSSItem(corporateindividualFormSSKey, corporateindividual);
    await openNewRequestModal({
      context: { address, city, cityGroupName, prefecture },
      dispatch,
      properties: { initialValues: { address, age, corporateindividual, propertyType }, jobTypeId },
    });
  },
});

export type ReduxProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(BannerZipcode);
